/**
 * Config compartida para las tarjetas de medidor circular (radialBar de
 * ApexCharts) -- inspirado en el "Repeat Customer Rate" de la referencia
 * visual compartida. Un solo valor porcentual, número grande centrado.
 */
export function buildRadialGaugeOptions(color: string, label: string) {
  return {
    chart: { sparkline: { enabled: true } },
    colors: [color],
    stroke: { lineCap: 'round' },
    plotOptions: {
      radialBar: {
        hollow: { size: '55%' },
        track: { background: '#f1f2f6' },
        dataLabels: {
          name: { show: false },
          value: {
            fontSize: '22px',
            fontWeight: 700,
            offsetY: 8,
            formatter: (val: number) => `${val}%`,
          },
        },
      },
    },
    labels: [label],
  };
}
